import React from "react";
import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn-in-nx/ui/select";
import { History } from "lucide-react";

function formatScanLabel(scan, t) {
    const date = new Date(scan.createdAt);
    const time = date.toLocaleString();
    const statusLabels = {
        COMPLETED: t("appPreview.statusCompleted"),
        FAILED: t("appPreview.statusFailed"),
        PENDING: t("appPreview.statusPending"),
        RUNNING: t("appPreview.statusRunning"),
    };
    const status = statusLabels[scan.status] || scan.status;
    const findings = scan.status === "COMPLETED" ? ` - ${scan.findingsCount || 0} ${t("appPreview.findings")}` : "";
    return `${time} (${status}${findings})`;
}

function CodeScanHistorySelect({ scanHistory, selectedScanId, onSelectScan }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-2 px-4 pt-3 pb-1">
            <History className="w-4 h-4 text-gray-500 shrink-0" />
            <Select value={selectedScanId || ""} onValueChange={onSelectScan}>
                <SelectTrigger className="h-8 text-xs">
                    <SelectValue placeholder={t("appPreview.selectScan")} />
                </SelectTrigger>
                <SelectContent>
                    {scanHistory.map((scan) => (
                        <SelectItem key={scan.id} value={scan.id} className="text-xs">
                            {formatScanLabel(scan, t)}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}

export default React.memo(CodeScanHistorySelect);
